const eventsBorders = () => {
    const events = document.querySelectorAll('.calendar .event-content');
    if (events.length === 0 ) return

    events.forEach( ev => {
        const cat = ev.querySelector('.spf-category-color a');
        if ( !cat ) return
        ev.style.borderColor = cat.style.background;
    } );
}

export default eventsBorders